<template>
  <div>
    <CoursesSearch @searchChange="search = $event" />
    <CoursesList
      :courses="courses.items"
      :pages-length="courses.pagesLength"
      :loading="courses.loading"
      :page="courses.page"
      :take="courses.take"
      @pageChanged="pageChanged"
    />
  </div>
</template>

<script>
import CoursesSearch from '@/components/manage/courses/CoursesSearch.vue';
import CoursesList from '@/components/manage/courses/CoursesList.vue';
import { trainingsMode } from '@/shared/enums';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('courses');

export default {
  components: {
    CoursesSearch,
    CoursesList
  },
  data: function() {
    return {
      search: ''
    };
  },
  computed: mapState(['courses']),
  watch: {
    search(value) {
      this.getAllCourses({
        search: value,
        page: 1
      });
    }
  },
  async mounted() {
    this.switchActiveMode({ mode: trainingsMode.DisplayCourses });
    await this.getAllCourses({
      search: this.search,
      page: 1
    });
  },
  methods: {
    ...mapActions(['switchActiveMode', 'getAllCourses']),
    async pageChanged(ev) {
      this.page = ev.page;
      await this.getAllCourses({
        search: this.search,
        page: ev.page
      });
    }
  }
};
</script>
